import courseFee from "./courseFee";

const courseFeeService = [
    {
        matcher: 'courseFee',
        reply: config => {
            return [200, courseFee];
        }
    }
]

export default courseFeeService;